import { setCategoryIdMain, setUserData } from "../redux/features/settingSlice";

const Logout = (dispatch) => {
  localStorage.removeItem("token");
  localStorage.removeItem("rt");
  dispatch(setUserData(null));
  dispatch(setCategoryIdMain(null));
};

export default Logout;
